import { TypeCurrentReport } from '@f_ucs/context/collector_context';

export const getReportActivity = (reports: TypeCurrentReport[]) => {
    return reports
        ?.filter((item: any) => item.reportActivity?.length)
        .map((item: any) =>
            item.reportActivity.map((obj: any) => {
                return { ...obj, time: item.time };
            }),
        )
        .flat(2) ?? null;
}

